import React from 'react';

import { ReactComponent as CommentIcon } from 'assets/icons/comment-new.svg';
import { ReactComponent as ArrrowRightIcon } from 'assets/icons/arrow-right-new.svg';
import TextField from 'clean/components/common/TextField/TextField';
import StyledTooltip from 'components/StyledTooltip/StyledTooltip';

import styles from './GradeInput.module.scss';

interface Props {
  currentGrade?: string;
  currentComment?: string;
  newGrade: string;
  setNewGrade: (value: string) => void;
  showVerticalLines?: boolean;
  inputOnly?: boolean;
  onKeyDown?: (e: any) => void;
}

const GradeInput: React.FC<Props> = ({
  currentGrade = '',
  currentComment = '',
  newGrade,
  setNewGrade,
  showVerticalLines,
  onKeyDown,
  inputOnly,
}) => {
  return (
    <div className={styles.gradeContainer}>
      {!inputOnly && (
        <>
          <div>{currentGrade}</div>

          <StyledTooltip
            tagName="div"
            direction="up"
            content={<p style={{ width: '200px', display: 'inline-block' }}>{currentComment}</p>}
          >
            <CommentIcon className={styles.commentIcon} />
          </StyledTooltip>

          <div className={styles.arrowIconContainer}>
            <ArrrowRightIcon />
            {showVerticalLines && <div className={styles.verticalLine1}></div>}
            {showVerticalLines && <div className={styles.verticalLine2}></div>}
          </div>
        </>
      )}
      <div className={styles.gradeInputContainer} style={{ marginLeft: inputOnly ? '' : '10px' }}>
        <TextField
          value={newGrade}
          onKeyDown={onKeyDown}
          onChange={e => {
            setNewGrade(e.target.value);
          }}
        />
      </div>
    </div>
  );
};

export default GradeInput;
